import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-2 px-1" }
const _hoisted_2 = { class: "col-12 col-md-5" }
const _hoisted_3 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_4 = { class: "col-12 col-md-2 form-group" }
const _hoisted_5 = { class: "form-check custom-checkbox form-check-inline pt-2 mt-4" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "same-as-attending"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Same as Attending")
], -1 /* HOISTED */)
const _hoisted_8 = { class: "col-12 col-md-5" }
const _hoisted_9 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_10 = { class: "col-12 col-md-4" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Add Additional Physician ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientPhysician = _resolveComponent("PatientPhysician")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Physicians",
    "full-height": false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_PatientPhysician, {
            label: _ctx.primaryPhysicianLabel,
            physicianId: _ctx.certifyingPhysicianId,
            "onUpdate:physicianId": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.certifyingPhysicianId) = $event)),
            lineOfServiceValue: _ctx.lineOfServiceValue,
            providerId: _ctx.patient.providerId,
            accountId: _ctx.accountId,
            onBlurredInput: _ctx.v$.patientDetails.certifyingPhysicianId.$touch,
            class: _normalizeClass(`${!_ctx.v$.patientDetails.certifyingPhysicianId.$error ? '' : 'mb-0'}`)
          }, null, 8 /* PROPS */, ["label", "physicianId", "lineOfServiceValue", "providerId", "accountId", "onBlurredInput", "class"]),
          (_ctx.v$.patientDetails.certifyingPhysicianId.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.primaryPhysicianLabel) + " is required.", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "same-as-attending",
              class: "form-check-input au-target",
              checked: _ctx.sameAttending,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sameAttending) = $event))
            }, null, 8 /* PROPS */, _hoisted_6), [
              [_vModelCheckbox, _ctx.sameAttending]
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_PatientPhysician, {
            label: "Attending Physician",
            physicianId: _ctx.attendingPhysicianId,
            "onUpdate:physicianId": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.attendingPhysicianId) = $event)),
            disabled: _ctx.sameAttending,
            lineOfServiceValue: _ctx.lineOfServiceValue,
            providerId: _ctx.patient.providerId,
            accountId: _ctx.accountId,
            onBlurredInput: _ctx.v$.patientDetails.attendingPhysicianId.$touch,
            class: _normalizeClass(`${!_ctx.v$.patientDetails.attendingPhysicianId.$error ? '' : 'mb-0'}`)
          }, null, 8 /* PROPS */, ["physicianId", "disabled", "lineOfServiceValue", "providerId", "accountId", "onBlurredInput", "class"]),
          (_ctx.v$.patientDetails.attendingPhysicianId.$error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Attending Physician is required."))
            : _createCommentVNode("v-if", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patient?.additionalPhysicians, (additionalPhysician, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_PatientPhysician, {
              label: "Additional Physician",
              physicianId: _ctx.patient.additionalPhysicians[index],
              "onUpdate:physicianId": ($event: any) => ((_ctx.patient.additionalPhysicians[index]) = $event),
              providerId: _ctx.patient.providerId,
              accountId: _ctx.accountId
            }, null, 8 /* PROPS */, ["physicianId", "onUpdate:physicianId", "providerId", "accountId"])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewPhysician && _ctx.addNewPhysician(...args)))
          }, _hoisted_14)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}